var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.application)?_c('transition',{attrs:{"name":"modal"}},[_c('el-dialog',{attrs:{"visible":_vm.dialogVisible,"before-close":_vm.closeDetail,"close-on-click-modal":false,"title":"Информация о заявителе"},on:{"update:visible":function($event){_vm.dialogVisible=$event}}},[_c('item-detail')],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }